import { DatabaseStatus } from '@/utils/interfaces';
import {
  Country,
  Language,
  nullOrNumber,
  nullOrString,
  PriorityEnum
} from '@proprioo/hokkaido';

import { SquadAgent, UserRole } from '../../state/interfaces';

export enum ContractType {
  AGENTCO = 'AGENTCO',
  CDI = 'CDI',
  IREC = 'IREC'
}

export enum Experience {
  RECONVERSION = 'reconversion',
  JUNIOR = 'junior',
  EXPERIENCED = 'experienced'
}

export enum PerformanceStatus {
  GOLD = 'gold',
  SILVER = 'silver'
}

export type LeadPriorities = {
  hasLow: boolean;
  hadMedium: boolean;
  hasHigh: boolean;
};

export type AgentArticleProps = {
  agentId: nullOrNumber;
  title: nullOrString;
  url: nullOrString;
  uid?: string;
};

export type AgentPage = {
  agentId: nullOrNumber;
  articles: AgentArticleProps[];
  careerStart?: nullOrString;
  keyToSuccess: nullOrString;
  neighborhoodHighlights: nullOrString;
  toBeAgent: nullOrString;
};

export type AgentChatId = {
  chat_id: string;
  id: number;
};

export type UserInfoPayload = {
  about: nullOrString;
  email: string;
  id: nullOrString;
  language: Language;
  modifiedBy: nullOrString;
  nom: string;
  prenom: string;
  promotional_consent: boolean;
  roles: UserRole[];
  tel: string;
};

export type CleanedAgentUser = Pick<
  UserInfoPayload,
  'about' | 'email' | 'id' | 'language' | 'modifiedBy' | 'roles'
> & {
  firstname: string;
  lastname: string;
  phone: string;
  promotionalConsent: boolean;
};

export type AgentPayload = {
  activation_date: nullOrString;
  bio: nullOrString;
  book: nullOrString;
  chat_id: nullOrString;
  contract_type: ContractType;
  country: Country;
  createdAt: nullOrString;
  custom_phone: nullOrString;
  diagnosisAffiliatedLink: nullOrString;
  displayAddress: string;
  email: string;
  end_activation_date: nullOrString;
  entry_date: nullOrString;
  experience?: Experience;
  externalId: nullOrString;
  facebook: nullOrString;
  firstname: string;
  id: nullOrNumber;
  instagram: nullOrString;
  language: Language;
  lastname: string;
  latitude: nullOrNumber;
  lead_priorities: PriorityEnum[];
  linkedin: nullOrString;
  longitude: nullOrNumber;
  modifiedAt: nullOrString;
  page: AgentPage;
  performanceStatus?: PerformanceStatus;
  phone: string;
  rsac_number: nullOrString;
  salesforce_id: string;
  squads: SquadAgent[];
  status: DatabaseStatus;
  status_reason: nullOrString;
  twitter: nullOrString;
  user: UserInfoPayload;
  user_id: nullOrString;
  youtubeIntroduction: nullOrString;
};

export type CleanedAgent = Omit<
  AgentPayload,
  | 'activation_date'
  | 'book'
  | 'chat_id'
  | 'contract_type'
  | 'custom_phone'
  | 'end_activation_date'
  | 'entry_date'
  | 'lead_priorities'
  | 'rsac_number'
  | 'salesforce_id'
  | 'status_reason'
  | 'user'
  | 'user_id'
> & {
  activationDate: nullOrString;
  bookId: nullOrString;
  chatId: nullOrString;
  contractType: ContractType;
  customPhone: nullOrString;
  endActivationDate: nullOrString;
  entryDate: nullOrString;
  leadPriorities: PriorityEnum[];
  rsacNumber: nullOrString;
  salesforceId: string;
  statusReason: nullOrString;
  user: CleanedAgentUser;
  userId: nullOrString;
};
